import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { useConfigStore } from '@/stores/configStore';

interface ShopFnbFacilityBuildingOptionButtonProps extends BaseButtonProps {
    title: string;
    onClick: () => void;
}

const ShopFnbFacilityBuildingOptionButton = ({ title, onClick, ...props }: ShopFnbFacilityBuildingOptionButtonProps) => {
    const contrast = useConfigStore((s) => s.config?.ui?.contrast);

    return (
        <BaseButton
            className={clsx(styles['option-button'], {
                [styles['option-button--active']]: props['aria-checked'],
                [styles['option-button--active--contrast']]: props['aria-checked'] && contrast,
            })}
            onClick={onClick}
            {...props}
        >
            <span>{title}</span>
        </BaseButton>
    );
};

export default ShopFnbFacilityBuildingOptionButton;
